<template>
    <div class="form-input-layout">
        <div :class="{'form-input-layout-caption': true, 'active': active}">
            <slot name="caption"/>
            <context-help v-if="helpItemCode != undefined" :help-item-code="helpItemCode"/>
        </div>
        <div class="form-input-layout-input">
            <slot name="input"/>
        </div>

    </div>
</template>

<script>
    import SimpleButton from "../button/SimpleButton";
    import ContextHelp from "../help/ContextHelp";
    export default {
        name: "FormInputLayout",
        components: {ContextHelp, SimpleButton},
        props: {
            active: Boolean,
            helpItemCode: String
        },
        data: function () {
            return {

            }
        },
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/global";

    .form-input-layout {
        color: var(--card-font-color);
        display: contents;
        align-items: baseline;
        width: 100%;
        overflow: visible;
    }

    .form-input-layout-input {

        position: relative;
        overflow: visible;
    }

    .form-input-layout-caption {

        text-align: right;
        display: flex;
        flow: row;
        justify-content: flex-end;
    }

    .active {
        color: var(--input-active-font-color);
    }

    .help-icon {
        padding-left: 10px;
    }
</style>